<template>
    <div class="ignore page-wrapper">
        <div class="paragraph">
            <h3>Q1. 注册时提示：统一社会信用代码无效，怎么处理？</h3>
            <p>答：1、检查统一社会信用代码是否填写错误；
                2、查询统一社会信用代码在《企查查》中是否存在且状态为【存续】；
                    企查查链接：https://www.qichacha.com/；或微信小程序搜索《企查查》
                3、检查统一社会信用代码与公司全称是否与《企查查》中一致；
                4、如果以上都无误，请反馈给云印客服或销售，提供统一社会信用代码及当前采购账号，客服查询并添加后即可登录。</p>
        </div>
        <div class="paragraph">
            <h3>Q2. 采购账号登录了，为什么无法查看报价单？</h3>
            <p>答：1、确认供应商给当前采购账号发布过报价单；
                2、检查报价单是否超过失效日期，如已经超过需要重新发布。</p>
        </div>
        <div class="paragraph">
            <h3>Q3. 采购下单时，地址展示暂无怎么处理？</h3>
            <p>答：1、点击「收货地址」查看采购地址列表中是否存在收货地址；
            2、如果不存在，则需要增加地址；
            注：固定报价单不能选择收货地址，固定报价单的收货地址为供应商发布报价单时选择的收货地址；其他下单时可选择收货地址。</p>
        </div>
        <div class="paragraph">
            <h3>Q4. 采购下单时，提示宽度不在限制范围内怎么处理？</h3>
            <p>答：1、与供应商确认是否在配置计价逻辑时选择了配置限定宽度；
                2、如果配置了限定宽度，采购在下单时只能按照限定的宽度值进行下单，不可填写其他数值。
                注：在配置的限定宽度的情况下，采购需要增加填写生产宽度，以下单宽*长计价，生产宽度作为二级厂生产依据。</p>
        </div>
        <div class="paragraph">
            <h3>Q5. 采购下单时，提示请填写压线信息怎么处理？保存压线信息后才会计算金额及面积吗？</h3>
            <p>答：1、下单时需要填写纸板的压线信息，分为毛边、净边无压线、净边有压线；净边有压线的情况下需要填写压线尺寸，压线尺寸之和=下单时填写的宽度；
            2、压线信息保存不成功时，需要根据提示查看是否压线值填写有误；
            3、压线信息保存成功后，返回填写下单参数页面，此时会计算配材的金额及面积。</p>
        </div>
        <div class="paragraph">
            <h3>Q6. 客户购买报价单配材B41时，基础报价单发布价格为0.81元/千平方英寸，特价为0.75元/千平方英寸，此时怎么判断购买哪种价格配材？</h3>
            <p>答：1、确认基础报价单和特价报价单是否存在加减价，如果存在则需要在单价的基础上加减价；
            2、确认客户是否存在折扣比例，如果存在则基础报价需要计算折扣后金额，特价不计算折扣；
            3、确认基础报价单和特价报价单是否存在换纸换楞加价，如果存在则需要在单价的基础上加价；
            4、如果以上三点都计算后，判断基础报价单的金额和特价单的金额取最小值。
                注：如果最小值的起售条件不满足会自动取倒数第二小值，如果倒数第二小值不支持，会取倒数第三小值，依次类推，如果几种起售面积都不支持会提示不可下单，请返回修改下单参数。</p>
        </div>
        <div class="paragraph">
            <h3>Q7. 客户如果存在一个单下多个材质或规格的情况下怎么操作最方便？采购下单时，批量导入订单模板报错怎么处理？</h3>
            <p>答：1、多个材质或者多个规格的下单，最方便的操作是在下单时下载订单导入模板，需要购买纸板时，根据文档规范填写下单参数，上传订单模板就可导入全部下单参数；
            2、批量导入时，提示“模板有误，解析失败”需要查看上传文档是否是下载模板，如果不一致会导致解析失败，无法导入；
            3、批量导入时，提示“第1行压线有误”、“第2行宽度有误”等提示，需要根据提示去查看对应行的数据是否填写错误，是否满足二级厂的接单条件。</p>
        </div>
        <div class="paragraph">
            <h3>Q8. 采购下错单，需要取消订单应该怎么处理？</h3>
            <p>答：1、确认订单是否已接单，如果未接单，可在「订单列表」直接取消；
            2、如果订单已接单，需要联系二级厂营管，由营管根据是否进入生产判断是否取消；营管取消时只能单个商品取消，如果一个订单多个商品，可根据实际情况取消部分或者全部；</p>
        </div>
        <div class="paragraph">
            <h3>Q9. 客户需要对同一材质同一规格材质多次购买时，怎么操作？</h3>
            <p>答：1、在订单列表及订单详情都有「再次购买」按钮，点击再次购买，可将上次订单的全部下单参数直接带入；
            2、如果二级厂修改配置，导致部分数据失效需要重新填写；
            3、如果购买团购，团购下架之后不可再次购买。</p>
        </div>
        <div class="paragraph">
            <h3>Q10. 货物存在质量问题或者缺数时，需要退款时怎么处理？</h3>
            <p>答：1、需要退款时，可以由采购公司（三级厂）发起售后；
            2、二级厂售后处理完成之后，如果现金支付会将退款原路退回到账户；
            3、如果是账期，则会根据退款金额恢复客户的账期额度。</p>
        </div>
        <div class="paragraph">
            <h3>Q11. 采购需要修改手机号码时应该怎么处理？</h3>
            <p>答：1、采购账号在PC端导航栏账号信息→「修改手机号码」即可修改，需要根据手机验证码验证，验证成功后可修改手机号码并重新登录；
            2、采购账号在App端「我的」→「设置」→「修改手机号码」即可修改，需要当前手机号码获取验证码进行验证，验证成功后输入新的手机号码获取验证码，验证码成功后可用修改后的手机号码进行登录。</p>
        </div>
        <div class="paragraph">
            <h3>Q12. 添加员工账号失败怎么处理？</h3>
            <p>答：1、管理员添加员工采购账号时，需要注意手机号码是否输入错误；
            2、已经注册这个供应商的手机号码不能添加为采购账号。</p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'faq',
    created() {
        document.title = '常见问题'
    }
}
</script>

<style lang="less" scoped>
    .ignore.page-wrapper {
        font-family: PingFang-SC-Regular;
        overflow: auto;
        font-size: 14px;
        padding: 20px;
        line-height: 1.6em;
        text-align: justify;
        h3 {
            font-size: 14px;
            font-weight: 700;
        }
    }
    .paragraph {
        margin-bottom: 1em;
    }
</style>
